import React, { useEffect, useState } from 'react'
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from './CheckoutForm'
import { useLocation } from 'react-router-dom';
const stripePromise = loadStripe('pk_test_51NiEqdSIbUtFJD0nYrLtnJD3teT59WcKbjGJDfnQ4lweF5L5WIp7mB2UIKusOvkF4ZEJCpE2yKU0244OjCtgcRfS00VBlX7KQy');
const Checkout = () => {
    const location = useLocation();
    const selectedProduct = location?.state;

    const history = location?.history;

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <Elements stripe={stripePromise}>
            <CheckoutForm selectedPrice={selectedProduct?.price} subscriptionType={selectedProduct?.plan_id} />
        </Elements>
    )
}

export default Checkout